import axios from 'axios';
import { I18n } from 'vue-i18n';
import { Store } from 'vuex';
import dayjs from 'dayjs';

export default class TranslationService {
  private store: Store<unknown>;
  private i18n: I18n;

  constructor(store: Store<unknown>, i18n: I18n) {
    this.store = store;
    this.i18n = i18n;
  }

  public refreshTranslation(newLanguage: string) {
    let currentLanguage = this.store.getters.currentLanguage;
    currentLanguage = newLanguage ? newLanguage : 'fr';
    const global: any = this.i18n.global;
    // vue-i18n 9 pré-crée un objet vide `{ [locale]: {} }` pour la locale/fallback : on ne peut pas se contenter
    // de tester la présence de la clé (toujours truthy), il faut vérifier qu'elle contient réellement des messages,
    // sinon le fetch paresseux ne part jamais et les libellés restent bruts.
    const existing = global.messages.value[currentLanguage];
    if (this.i18n && (!existing || Object.keys(existing).length === 0)) {
      global.setLocaleMessage(currentLanguage, {});
      axios.get(`i18n/${currentLanguage}.json?_=${I18N_HASH}`).then((res: any) => {
        if (res.data) {
          global.setLocaleMessage(currentLanguage, res.data);
          this.setLocale(currentLanguage);
        }
      });
    } else if (this.i18n) {
      this.setLocale(currentLanguage);
    }
  }

  private setLocale(lang: string) {
    dayjs.locale(lang);
    (this.i18n.global as any).locale.value = lang;
    this.store.commit('currentLanguage', lang);
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
  }
}
